import React from "react";

function Account(props) {
  const getToken = async () => {
    try {
      const baseUrl = 'https://sso-stage.nemea.cloud/realms/spid/protocol/openid-connect/auth';
      const redirectUri = `${window.location.origin}/callback`;
      const uniqueId = `SPID-${Date.now()}.${Math.random()}`;
      
      const codeVerifier = generateCodeVerifier();
      const codeChallenge = await generateCodeChallenge(codeVerifier);
      
      localStorage.setItem('code_verifier', codeVerifier);
      localStorage.setItem('redirect_uri', redirectUri);
      
      const params = new URLSearchParams({
        response_type: 'code',
        client_id: 'account-console',
        state: uniqueId,
        redirect_uri: redirectUri,
        scope: 'openid profile email phone',
        nonce: uniqueId,
        code_challenge: codeChallenge,
        code_challenge_method: 'S256'
      });

      const finalUrl = `${baseUrl}?${params.toString()}`;
      window.location.href = finalUrl;
    } catch (err) {
      console.error('error during SPID redirect', err);
      alert('Errore durante il redirect SPID: ' + err.message);
    }
  };

  function generateCodeVerifier() {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    return base64URLEncode(array);
  }

  function base64URLEncode(buffer) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  }

  async function generateCodeChallenge(verifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await window.crypto.subtle.digest('SHA-256', data);
    return base64URLEncode(digest);
  }

  return (
    <div className="it-header-slim-right-zone" role="navigation">
      <a
        className="btn btn-primary btn-icon btn-full"
        href="#"
        onClick={getToken}
        data-element="personal-area-login"
        data-focus-mouse="false"
      >
        <span className="rounded-icon" aria-hidden="true">
          <svg className="icon icon-primary">
            <use xlinkHref="../assets/bootstrap-italia/dist/svg/sprites.svg#it-user" />
          </svg>
        </span>
        <span className="d-none d-lg-block">Accedi all'area personale</span>
      </a>
    </div>
  );
}

export default Account;
